import React from 'react';
import { Link } from 'react-router-dom';
import API from '../../servicios/api';

import tipoDocs from '../../data/tipodoc.json';
import tipoGeneros from '../../data/generos.json';
import tipoEstadocivil from '../../data/estadocivil.json';
import tipoEducacion from '../../data/tipoeducacion.json';
import tipoParentesco from '../../data/parentesco.json';
import tipoProgramas from '../../data/tipoprogramas.json';

class Familiares extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            datosCargados:false,
            empleado_docId: "",
            empleado_claveAPI: "",
            familiares: [],
            errores: [],
            serverror: ""
         };
    }

    componentDidMount(){
        const k = this.props.match.params.claveapi_docId; 
        const keyAPI = k.split('_')[0]; 
        const docId = k.split('_')[1];
        this.setState({empleado_docId: docId, empleado_claveAPI: keyAPI});
        this.setState({ 
            datosCargados:true,
            familiares: { claveAPI:keyAPI,
                tipodoc:"C.C.", beneficiarioId:docId, docId:"", genero:"M",
                nombre:"", apellidos:"", parentesco:"Seleccionar...", fechanacimiento:"",
                edad:"", estadocivil:"Seleccionar...", niveleducativo:"Seleccionar...", nivel:"0", estudiaactualmente:"No",
                ocupacion:"", viveconbeneficiario:"Si", direccion:"", telefono:"", celular:"", 
                trabaja:"No", programaprincipal:"Seleccionar..."
            }
        });
    }

    cambioValor = (e) =>{
        const state = this.state.familiares;
        state[e.target.name] = e.target.value;
        state["edad"] = (state.edad) ? state.edad : 0;
        if (e.target.name==="fechanacimiento"){
            const edad = this.calcularEdad(e.target.value);
            state.edad = edad;
        }
        this.setState( { familiares:state, errores:[], serverror:""});
    }

    calcularEdad = (f) =>{
        // console.log(f);
        const fn = f.split('-');
        const birth_year = fn[0];
        const birth_month = fn[1];
        const birth_day = fn[2];
        const today_date = new Date();
        const today_year = today_date.getFullYear();
        const today_month = today_date.getMonth();
        const today_day = today_date.getDate();
        let age = today_year - birth_year;
        
        if (today_month < (birth_month - 1)) {
            age--;
        }
        if (((birth_month - 1) === today_month) && (today_day < birth_day)) {
            age--;
        }
        return age;
    }

    verificarError(elm){
        return this.state.errores.indexOf(elm) !== -1;
    }

    enviarDatos = (e) => {
        e.preventDefault();
        let { claveAPI,
            tipodoc, beneficiarioId, docId, genero,
            nombre, apellidos, parentesco, fechanacimiento,
            edad, estadocivil, niveleducativo, nivel, estudiaactualmente,
            ocupacion, viveconbeneficiario, direccion, telefono, celular,
            trabaja, programaprincipal
        } = this.state.familiares;

        // Validar Errores
        let errores = [];
        if (!beneficiarioId) errores.push('error_beneficiarioId');
        if (!docId) errores.push('error_docId');
        if (!tipodoc) errores.push('error_tipodoc');
        if (!genero) errores.push('error_genero');
        if (!nombre) errores.push('error_nombre');
        if (!apellidos) errores.push('error_apellidos');
        if (!parentesco) errores.push('error_parentesco');
        if (!fechanacimiento) errores.push('error_fechanacimiento');
        // if (!edad) errores.push('error_edad');
        if (!estadocivil) errores.push('error_estadocivil');
        if (!niveleducativo) errores.push('error_niveleducativo');
        if (!nivel) errores.push('error_nivel');
        if (!estudiaactualmente) errores.push('error_estudiaactualmente');
        if (!ocupacion) errores.push('error_ocupacion');
        if (!viveconbeneficiario) errores.push('error_viveconbeneficiario');
        // if (!direccion) errores.push('error_direccion');
        // if (!celular) errores.push('error_celular');
        // if (!telefono) errores.push('error_telefono');
        if (!trabaja) errores.push('error_trabaja');
        if (!programaprincipal) errores.push('error_programaprincipal');

        if(tipodoc==="Seleccionar...") errores.push('error_tipodoc');
        if(genero==="Seleccionar...") errores.push('error_genero');
        if(estadocivil==="Seleccionar...") errores.push('error_estadocivil');
        if(parentesco==="Seleccionar...") errores.push('error_parentesco');
        if(niveleducativo==="Seleccionar...") errores.push('error_niveleducativo');
        if(programaprincipal==="Seleccionar...") errores.push('error_programaprincipal');
        
        this.setState({errores:errores});
        if (errores.length>0) {
            console.log(errores);
            return false;
        }

        estudiaactualmente = (estudiaactualmente.toLocaleLowerCase()==="si") ? "1": "0";
        viveconbeneficiario = (viveconbeneficiario.toLocaleLowerCase()==="si") ? "1": "0";
        trabaja = (trabaja.toLocaleLowerCase()==="si") ? "1": "0";
        
        var datosaEnviar = { claveAPI:claveAPI, beneficiarioId:beneficiarioId, 
            docId:docId, tipodoc:tipodoc, genero:genero, nombre:nombre, apellidos:apellidos, 
            parentesco:parentesco, fechanacimiento:fechanacimiento, edad:edad, estadocivil:estadocivil, 
            niveleducativo:niveleducativo, nivel:nivel, estudiaactualmente:estudiaactualmente,
            ocupacion:ocupacion, viveconbeneficiario:viveconbeneficiario, direccion:direccion, 
            telefono:telefono, celular:celular, trabaja:trabaja, programaprincipal:programaprincipal
        };
        // console.log(datosaEnviar);
        fetch(API +"?addFamiliar=1", {
            method:"POST",
            body: JSON.stringify(datosaEnviar)
        })
        .then(respuesta => respuesta.json())
        .then((datos)=>{
            // console.log(datos);
            if (datos.error && datos.error!==""){
                this.setState({serverror:datos.error});
            } else {
                this.props.history.push("/familiares/"+datos.claveAPI+"_"+datos.docId);
            }
        })
        .catch(console.log)
    }

    render() { 

        const { 
            datosCargados, familiares, serverror
        } = this.state;
        let { 
            claveAPI, 
            tipodoc, beneficiarioId, docId, genero,
            nombre, apellidos, parentesco, fechanacimiento,
            edad, estadocivil, niveleducativo, nivel, estudiaactualmente,
            ocupacion, trabaja, programaprincipal, viveconbeneficiario, direccion, telefono, celular
        } = familiares;
       
        if (!datosCargados) {
            return(<div><div className="spinner-border text-success"></div>Cargando datos...</div>);
        } else {
            return ( 
            <div className="card">
                <div className="card-header">
                    <div className='encuesta-title'>
                        <div><strong>FAMILIARES</strong></div>
                        <div>5 de 5</div>
                    </div>
                </div>
                <div className="card-body">
                    <form onSubmit={this.enviarDatos}>
                        <div className="form-group oculto">
                            <label htmlFor=""><strong>Número Documento Empleado</strong></label>
                            <input readOnly type="text" name="beneficiarioId" value={beneficiarioId} onChange={this.cambioValor} id="beneficiarioId"
                                className={((this.verificarError("error_beneficiarioId")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                            <small id="helpId" className="invalid-feedback">Dígite su número de identificación sin espacios, puntos o comas.</small>
                        </div><div className="form-group oculto">
                            <label htmlFor=""><strong>claveAPI</strong></label>
                            <input readOnly type="text" name="claveAPI" value={claveAPI} onChange={this.cambioValor} id="claveAPI"
                                className={((this.verificarError("error_claveAPI")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                            <small id="helpId" className="invalid-feedback">valor no válido</small>
                        </div>

                        <label htmlFor=""><strong>Información del Familiar</strong></label>
                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Tipo</strong></label>
                                <div className="dropdown">
                                    <button className="btn btn-info dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {tipodoc}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        {tipoDocs.tipo.map(e => {
                                            return (
                                                // <a key={e.id} className="dropdown-item" href="#">{e.name}</a>
                                                <button onClick={this.cambioValor} key={e.id} name="tipodoc" value={e.name} className="dropdown-item" type="button">{e.name}</button>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>

                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Número Documento</strong></label>
                                <input type="text" name="docId" value={docId} onChange={this.cambioValor} id="docId"
                                    className={((this.verificarError("error_docId")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Dígite su número de identificación sin espacios, puntos o comas.</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Género</strong></label>
                                <div className="dropdown dropleft">
                                    <button className="btn btn-info" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {genero}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        {tipoGeneros.tipo.map(e => {
                                            return (
                                                <button onClick={this.cambioValor} key={e.id} name="genero" value={e.value} className="dropdown-item" type="button">{e.name}</button>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Nombres</strong></label>
                                <input type="text" name="nombre" value={nombre} onChange={this.cambioValor} id="nombre"
                                    className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Dígite los nombres con espacio y utilizando las tildes si lo requieren.</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Apellidos</strong></label>
                                <input type="text" id="apellidos" name="apellidos" value={apellidos} onChange={this.cambioValor}
                                    className={((this.verificarError("error_apellidos")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Dígite el apellido sin espacio y utilizando las tildes si lo requieren.</small>
                            </div>
                        </div>

                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Parentesco</strong></label>
                                <div className={((this.verificarError("error_parentesco")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                    <button className="btn btn-info dropdown-size" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {parentesco}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        {tipoParentesco.tipo.map(e => {
                                            return (
                                                <button onClick={this.cambioValor} key={e.id} name="parentesco" value={e.name} className="dropdown-item" type="button">{e.name}</button>
                                            )
                                        })}
                                    </div>
                                </div>
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Fecha de Nacimiento</strong></label>
                                <input type="date" id="fechanacimiento" name="fechanacimiento" value={fechanacimiento} onChange={this.cambioValor}
                                    className={((this.verificarError("error_fechanacimiento")) ? "is-invalid" : "") + " form-control form-control-inline"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                        </div>

                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Estado Civil</strong></label>
                                <div className={((this.verificarError("error_estadocivil")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                    <button className="btn btn-info dropdown-size" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {estadocivil}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        {tipoEstadocivil.tipo.map(e => {
                                            return (
                                                <button onClick={this.cambioValor} key={e.id} name="estadocivil" value={e.name} className="dropdown-item" type="button">{e.name}</button>
                                            )
                                        })}
                                    </div>
                                </div>
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor="">Edad</label>
                                <input readOnly type="number" id="edad" name="edad" value={edad} onChange={this.cambioValor}
                                    className={((this.verificarError("error_edad")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                        </div>

                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Nivel Educativo</strong></label>
                                <div className={((this.verificarError("error_niveleducativo")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                    <button className="btn btn-info dropdown-size" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {niveleducativo}
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-longlist" aria-labelledby="dropdownMenu2">
                                        {tipoEducacion.tipo.map(e => {
                                            return (
                                                <button onClick={this.cambioValor} key={e.id} name="niveleducativo" value={e.name} className="dropdown-item" type="button">{e.name}</button>
                                            )
                                        })}
                                    </div>
                                </div>
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Nivel de Escolaridad</strong></label>
                                <input type="number" id="nivel" name="nivel" value={nivel} onChange={this.cambioValor}
                                    className={((this.verificarError("error_nivel")) ? "is-invalid" : "") + " form-control"} placeholder="0" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Dígite el número del último grado o semestre que cursó y aprobó.</small>
                            </div>
                        </div>

                        <div className="form-group-inline">
                            <div className="form-group">
                                <label htmlFor=""><strong>Estudia Actualmente?</strong></label>
                                <div className="dropdown">
                                    <button className="btn btn-info dropdown-size"
                                        type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {estudiaactualmente}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        <button onClick={this.cambioValor} key={1} name="estudiaactualmente" value="Si" className="dropdown-item" type="button">Si</button>
                                        <button onClick={this.cambioValor} key={2} name="estudiaactualmente" value="No" className="dropdown-item" type="button">No</button>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Vive con usted?</strong></label>
                                <div className="dropdown">
                                    <button className="btn btn-info dropdown-size"
                                        type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {viveconbeneficiario}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        <button onClick={this.cambioValor} key={1} name="viveconbeneficiario" value="Si" className="dropdown-item" type="button">Si</button>
                                        <button onClick={this.cambioValor} key={2} name="viveconbeneficiario" value="No" className="dropdown-item" type="button">No</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Ocupación</strong></label>
                                <input type="text" id="ocupacion" name="ocupacion" value={ocupacion} onChange={this.cambioValor}
                                    className={((this.verificarError("error_ocupacion")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Trabaja?</strong></label>
                                <div className="dropdown">
                                    <button className="btn btn-info dropdown-size"
                                        type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {trabaja}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        <button onClick={this.cambioValor} key={1} name="trabaja" value="Si" className="dropdown-item" type="button">Si</button>
                                        <button onClick={this.cambioValor} key={2} name="trabaja" value="No" className="dropdown-item" type="button">No</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor=""><strong>Programa en el cual desearía participar?</strong></label>
                            <div className={((this.verificarError("error_programaprincipal")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                <button className="btn btn-info dropdown-size-2" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {programaprincipal}
                                </button>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                    {tipoProgramas.tipo.map(e => {
                                        return (
                                            <button onClick={this.cambioValor} key={e.id} name="programaprincipal" value={e.name} className="dropdown-item" type="button">{e.name}</button>
                                        )
                                    })}
                                </div>
                            </div>
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div>
                        {(viveconbeneficiario === "No")
                            ? <div>
                                <div className="form-group">
                                    <label htmlFor=""><strong>Dirección residencia actual</strong></label>
                                    <input type="text" id="direccion" name="direccion" value={direccion} onChange={this.cambioValor}
                                        className={((this.verificarError("error_direccion")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                    <small id="helpId" className="invalid-feedback">Registro no válido</small>
                                </div>
                                <div className="form-group-inline">
                                    <div className="form-group separate-input-small">
                                        <label htmlFor=""><strong>Celular</strong></label>
                                        <input type="text" id="celular" name="celular" value={celular} onChange={this.cambioValor}
                                            className={((this.verificarError("error_celular")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                        <small id="helpId" className="invalid-feedback">Dígite el número de celular sin espacios o guiones, solo dígite números</small>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor=""><strong>Teléfono fijo</strong></label>
                                        <input type="text" id="telefono" name="telefono" value={telefono} onChange={this.cambioValor}
                                            className={((this.verificarError("error_telefono")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                        <small id="helpId" className="invalid-feedback">Dígite el número de telefono sin espacios o guiones, solo dígite números</small>
                                    </div>
                                </div>
                            </div>
                            : <></>
                        }

                        <div className="server-error">{serverror}</div>
                        
                        <hr width="90%" />
                        <div className="btn-group btn-acciones" aria-label="">
                            <div><Link to={"/familiares/" + claveAPI + "_" + beneficiarioId} className="btn btn-outline-danger btn-size-sm">Cancelar</Link></div>
                            <div><button type="submit" className="btn btn-success">Agregar Familiar</button></div>

                        </div>

                    </form>
                    </div>
                {/* <div className="card-footer text-muted">
                    
                </div> */}

                {/* <hr width="100%" />
                <br></br>
                <div className="btn-group btn-acciones" aria-label="">
                    <div className='btn-size-sm'><Link to={"/perfil4/" + claveAPI} className="btn btn-warning btn-size-sm">Atras</Link></div>
                    <div><button type="button" className="btn btn-success">Finalizar</button></div>
                </div> */}
            </div>
        );
        }
    }
}

export default Familiares;